import { PropsWithChildren } from "react";

import { useUser } from "../user/UserProvider";
import { TutorialPage } from "./TutorialPage";
import { useTaskResponseAction } from "../task/task-response-action.hook";
import { Tutorial } from "../gardener/gardener.model";
import { Layout } from "../application/Layout";
import { useLocation } from "react-router-dom";

export const GlobalBlockingTutorialRouter = (props: PropsWithChildren<{}>) => {
    const { children } = props;

    const taskResponseAction = useTaskResponseAction();

    const gardener = useUser();

    const location = useLocation();

    const exemptLocation = (() => {
        if ( location.pathname === "/profile" ) return true;
        if ( location.pathname === "/cooperation" ) return true;
        if ( location.pathname === "/agreements/create" ) return true;
        if ( location.pathname === "/delete-profile" ) return true;

        return false;
    })();

    if ( exemptLocation ) return <>{children}</>;

    const guide = ((): keyof Tutorial | null => {
        if ( gardener.status !== "active" ) return null;

        if ( gardener.tutorial.onboarding === "relevant" ) return "onboarding";
        if ( gardener.tutorial.appointmentTask === "relevant" ) return "appointmentTask";
        if ( gardener.tutorial.registrationTask === "relevant" ) return "registrationTask";
        if ( gardener.tutorial.afterRegistration === "relevant" ) return "afterRegistration";
        if ( gardener.tutorial.afterClosedTask === "relevant" ) return "afterClosedTask";

        return null;
    })();

    if ( guide ) {
        return (
            <Layout hideSidebar hideBanner hideGuides>
                <TutorialPage guide={guide} taskResponseAction={taskResponseAction} />
            </Layout>
        );
    }

    return <>{children}</>;
};
